import * as d3 from 'd3'
export default {
  methods: {

    draw_Header() {
      
      let head = this.header
      let tblLen = this.table.width

      let columns = this.canvasForms
      .append('g')
      .attr('transform', `translate(${head.x}, ${head.y+.5})`)

      columns
      .append('path') // shadow
      .attr('d', `M 30, ${head.height + 2} H ${this.timeline.length+tblLen - 30} L ${this.timeline.length + tblLen},${head.height + 8} H0 Z`)
      .attr('fill', `url(#shadowTimeline)`) 

      columns
      .append('rect') 
      .attr('x', 0).attr('y', 0).attr('width', tblLen).attr('height', 3)
      .attr('fill', `url(#${this.localId}_LightGray_)`)

      columns
      .append('rect')
      .attr('x', 0).attr('y', 3).attr('width', tblLen).attr('height', head.height)
      .attr('fill', `url(#${this.localId}_LightGray_)`).attr('opacity', .5)

      columns // Timenow
      .append('rect')
      .attr('x', 0).attr('y', 2).attr('width', tblLen + this.timeline.scale(new Date(this.timeline.cutoff)))
      .attr('height', head.height)
      .attr('fill', `url(#${this.localId}_LightBlue_)`).attr('opacity', .5)

      columns
      .append('rect') 
      .attr('x', 0).attr('y', head.height + 1).attr('width', tblLen).attr('height', 4)
      .attr('fill', `url(#${this.localId}_LightGray_)`)

      let tableHeader = columns
      .append('g')
      .attr('transform', `translate(0, 20)`)

      this.columns.forEach((d,i) => {
        tableHeader
        .append('text')
        .attr('x', d.mx).attr('y', 12*0.35)
        .attr('font-size', 12).attr('fill','#333').attr('font-weight', 450)
        .attr('text-anchor', 'middle')
        .text(d.name)
      })
    },


    draw_Timeline() {    
      let head = this.header
      let Timeline = this.canvasForms
      .append('g')
      .attr('transform', `translate(${this.timeline.x}, ${head.y+.5})`)

      Timeline
      .append('rect') 
      .attr('x', 0).attr('y', 0).attr('width', this.timeline.length).attr('height', 3)
      .attr('fill', `url(#${this.localId}_LightGray_)`).attr('opacity', .99)

      Timeline
      .append('rect')
      .attr('x', 0).attr('y', 3).attr('width', this.timeline.length).attr('height', head.height)
      .attr('fill', `url(#${this.localId}_LightGray_)`).attr('opacity', .5)

      Timeline
      .append('rect') 
      .attr('x', 0).attr('y', head.height + 1).attr('width', this.timeline.length).attr('height', 4)
      .attr('fill', `url(#${this.localId}_LightGray_)`)

      
      // Month Text & Timeline Seperator for the Month
      this.timeline.month.forEach((d,i)=> {

        Timeline
        .append('text')
        .attr('x', this.timeline.scale(d.mDate)).attr('y', 25 + this.timeline.month_tSize*0.75)
        .style('font-size', this.timeline.month_tSize).attr('fill', '#757575')
        .attr('text-anchor', 'middle')
        .text(d.name.toUpperCase().substr(0,this.timeline.month_format))

        Timeline
        .append('line')
        .attr('x1', this.timeline.scale(d.eDate)).attr('y1', 24)
        .attr('x2', this.timeline.scale(d.eDate)).attr('y2', 35)
        .attr('stroke', '#bcbcbc').attr('oapcity', .1)
        .attr('stroke-width', (i != this.timeline.month.length-1) ? 1 : 0)

      })
      
      // Year Text & Timeline Seperator for the Year
      this.timeline.year.forEach((d,i)=> {
        
        Timeline
        .append('text')
        .attr('x', this.timeline.scale(d.mDate)).attr('y', 8 + 11*0.75)
        .style('font-size', 11)
        .attr('fill', '#333').attr('text-anchor', 'middle')
        .text(d.name)

        Timeline
        .append('path')
        .attr('d', () => {
          if (i != this.timeline.year.length-1) return `M${this.timeline.scale(d.eDate)}, ${2} V${19}`
        })
        .attr('stroke', '#bcbcbc').attr('oapcity', .1)
        .attr('stroke-width', 1)
      })
    }, 

  }
}